import "@fontsource/roboto"
import "./src/styles/foundation/variable.css"
import "./src/styles/foundation/normalize.css"
import "./src/styles/foundation/base.css"
import "./src/styles/foundation/blog-contents-style.css"

// #movie などハッシュ付きで遷移してきた場合は、
// Gatsby標準のスクロール位置リセットと衝突しないよう無効化する
// （instructor/index.jsx側のuseEffectで制御するため）
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location?.hash) {
    return false
  }
  return true
}